import script from "./AdminNoticeCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminNoticeCard.vue?vue&type=script&setup=true&lang=ts"

import "./AdminNoticeCard.vue?vue&type=style&index=0&id=07b10c2a&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b10c2a"]])

export default __exports__